import C from './loadable';

export default C;
